// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputMapper_Input__NYDr_ {
  margin: 10px 0 0;
}
.InputMapper_Input__NYDr_:first-child {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/InputMapper/InputMapper.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,SAAA;AACR","sourcesContent":[".Input {\n    margin: 10px 0 0;\n\n    &:first-child {\n        margin: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Input": `InputMapper_Input__NYDr_`
};
export default ___CSS_LOADER_EXPORT___;
